import { jsxs, jsx } from "react/jsx-runtime";
const IconFileImportSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M9.167 16.667H5a.833.833 0 0 1-.833-.834V4.167A.833.833 0 0 1 5 3.333h4.167v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5V10a.834.834 0 0 0 1.666 0V7.45a1.084 1.084 0 0 0-.05-.225V7.15a1.098 1.098 0 0 0-.158-.242l-5-5a1.098 1.098 0 0 0-.242-.158.267.267 0 0 0-.075 0l-.258-.083H5a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h4.167a.834.834 0 0 0 0-1.666Zm1.666-12.159 2.159 2.159h-1.325a.833.833 0 0 1-.834-.834V4.508Zm5 7.992h-4.658l1.083-1.075a.836.836 0 1 0-1.183-1.183l-2.5 2.5a.958.958 0 0 0-.175.275.833.833 0 0 0 0 .633.775.775 0 0 0 .175.275l2.5 2.5a.833.833 0 0 0 1.183 0 .833.833 0 0 0 0-1.183l-1.083-1.075h4.658a.833.833 0 0 0 0-1.667Z" })
    ]
  }
);
export {
  IconFileImportSvg
};
